import React from 'react';
import { useNavigate } from 'react-router-dom';

import './Success.css'; // Подключаем стили

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="success-page">
      <div className="success-content">
        {/* Иконка */}
        <div className="success-icon">
          <svg width="119" height="119" viewBox="0 0 119 119" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M59.6 0.400024C26.9571 0.400024 0.400024 26.9571 0.400024 59.6C0.400024 92.2429 26.9571 118.8 59.6 118.8C92.2429 118.8 118.8 92.2429 118.8 59.6C118.8 26.9571 92.2429 0.400024 59.6 0.400024ZM59.6 108.036C32.8919 108.036 11.1637 86.3078 11.1637 59.6C11.1637 32.8922 32.8919 11.1637 59.6 11.1637C86.3082 11.1637 108.036 32.8922 108.036 59.6C108.036 86.3078 86.3078 108.036 59.6 108.036Z"
              fill="#29FC7D"
            />
            <path
              d="M81.7993 38.6695L51.3547 69.1138L37.4014 55.1601C35.3 53.0587 31.8922 53.0584 29.7904 55.1598C27.6887 57.2616 27.6887 60.669 29.7904 62.7708L47.549 80.53C48.5582 81.5393 49.927 82.1064 51.3543 82.1065H51.3547C52.7819 82.1065 54.1507 81.5393 55.16 80.5304L89.4102 46.2809C91.512 44.1791 91.512 40.7717 89.4102 38.6699C87.3085 36.5681 83.901 36.5678 81.7993 38.6695Z"
              fill="#29FC7D"
            />
          </svg>
        </div>

        {/* Заголовок */}
        <h1>Оплата прошла успешно!</h1>

        {/* Текст */}
        <p>Пароль от личного кабинета отправлен по указанному вами адресу электронной почты.</p>

        {/* Кнопки */}
        <div className="buttons">
          <button className="btn home-btn" onClick={() => navigate('/profile')}>
            На главную
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
